import { useNotificationBarStore } from '../store/notificationbar';

export default defineNuxtPlugin((nuxtApp) => {
  const store = useNotificationBarStore();
  nuxtApp.provide('notifier', {
    showMessage({ content = '', color = '' }) {
      store.showMessage({
        content,
        color
      });
    },
    setActionHeaderActive(payload) {
      store.setActionHeaderActive(payload);
    }
  });
});
